import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["details", "chevron", "toggle"]
  }

  static get values() {
    return { startOpen: Boolean }
  }

  connect() {
    const detailsPanel = this.detailsTarget
    detailsPanel.style.overflow  = "hidden"
    detailsPanel.style.transition = "max-height 0.3s ease"
    detailsPanel.classList.remove("tw-hidden")
    this.open = !!this.startOpenValue
    detailsPanel.style.maxHeight = this.open ? `${detailsPanel.scrollHeight}px` : "0"
    if (this.open) {
      this.chevronTarget.style.transform = "rotate(180deg)"
      if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", "true")
    }
  }

  toggle(event) {
    // Clicks on the edit button (and its modal trigger) must not collapse the card.
    if (event && event.target.closest("[data-card-collapse-ignore]")) return

    this.open = !this.open
    const detailsPanel = this.detailsTarget

    detailsPanel.style.maxHeight = this.open ? `${detailsPanel.scrollHeight}px` : "0"
    this.chevronTarget.style.transition = "transform 0.3s ease"
    this.chevronTarget.style.transform  = this.open ? "rotate(180deg)" : "rotate(0deg)"
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", this.open ? "true" : "false")
      this.toggleTarget.setAttribute("aria-label", this.open ? "Hide details" : "Show details")
    }
  }
}
